import React, { FC, useEffect, useState }  from 'react';
import { Select, Tag } from 'antd';
import type { CustomTagProps } from 'rc-select/lib/BaseSelect';
import { UserCardFilterProps } from './interfaces';
import { useTranslation } from 'react-i18next';
import styles from './Styles/DashboardBusinessControls.module.scss'
import { useAppContext } from '../../../system/providers/appContextProvider';
import { DashboardBusinessControlsDataProvider } from '../../../Services/DataProviders/DashboardBusinessControlsDataProvider';
import useGridFilter, { DefaultGridFilter } from '../../../system/hooks/useGridFilter';

const { Option } = Select;

const UserCardFilter: FC<UserCardFilterProps> = ({ onFilterChange, currentFilter, data }) => {

    const appContext = useAppContext();
    const dashboardBusinessControlsDP = new DashboardBusinessControlsDataProvider(appContext.coreApiService);
    const { t } = useTranslation();  
    const [contractors, setContractors] = useState<{id: string; name: string}[]>([]);
    const [selectedContractors, setSelectedContractors] = useState<string[]>([]);
    const [loading, setLoading] = useState(false);
            
    useEffect(() => {
        if (data && data.length > 0) {
            setLoading(true);
            const uniqueContractors = Array.from(new Set(data.map(item => ({
                id: item.idContractorGlobal,
                name: item.contractorName
            }))));
            
            setContractors(uniqueContractors);
            setLoading(false);
        }
    }, [data]);

    const filterOption = (inputValue: string, option: any) => {
        return option?.children?.toLowerCase().includes(inputValue.toLowerCase());
    };

    const handleChange = (value: string[]) => {
        setSelectedContractors(value);
        if (onFilterChange) {
            onFilterChange(value);
        }
    };

    const getColorForContractor = (contractorId: string): string => {
        // Генерируем цвет на основе ID контрагента
        const colors = [
            'magenta', 'red', 'volcano', 'orange', 'gold', 
            'lime', 'green', 'cyan', 'blue', 'geekblue', 'purple'
        ];
        const hash = contractorId.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
        return colors[hash % colors.length];
    };

    const tagRender = (props: CustomTagProps) => {
        const { label, value, closable, onClose } = props;
        const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
            event.preventDefault();
            event.stopPropagation();
        };
        
        return (
            <Tag
                onMouseDown={onPreventMouseDown}
                closable={closable}
                onClose={onClose}
                style={{ marginRight: 3 }}
                color={getColorForContractor(value)}
            >
                {label}
            </Tag>
        );
    };

    return (
        <Select
            className={styles.selectFilter}
            mode="multiple"
            showArrow
            showSearch
            loading={loading}
            placeholder={t("accounting.dashboardBusinessControls.filterPharmacies")}
            tagRender={tagRender}
            value={selectedContractors}
            onChange={handleChange}            
            optionLabelProp="label"
            filterOption={filterOption}
            optionFilterProp="children"
        >
            {contractors.map(contractor => (
                <Option 
                    key={contractor.id} 
                    value={contractor.id}
                    label={contractor.name}
                >
                    {contractor.name}
                </Option>
            ))}
        </Select>        
    );
};

export default UserCardFilter;